var map = {
	"./Auth/ConfirmPassword.vue": "./resources/js/Pages/Auth/ConfirmPassword.vue",
	"./Auth/ForgotPassword.vue": "./resources/js/Pages/Auth/ForgotPassword.vue",
	"./Auth/Login.vue": "./resources/js/Pages/Auth/Login.vue",
	"./Auth/Register.vue": "./resources/js/Pages/Auth/Register.vue",
	"./Auth/ResetPassword.vue": "./resources/js/Pages/Auth/ResetPassword.vue",
	"./Auth/VerifyEmail.vue": "./resources/js/Pages/Auth/VerifyEmail.vue",
	"./Dashboard.vue": "./resources/js/Pages/Dashboard.vue",
	"./Welcome.vue": "./resources/js/Pages/Welcome.vue",
	"./exhishare/Folder.vue": "./resources/js/Pages/exhishare/Folder.vue",
	"./exhishare/Start.vue": "./resources/js/Pages/exhishare/Start.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./resources/js/Pages sync recursive ^\\.\\/.*\\.vue$";